module.exports = __webpack_public_path__ + "static/img/card-front.5fd853c.png";